/*
 * Copyright (c) 2019. ProVision Media Group Ltd. <https://provision.bg>
 * Venelin Iliev <http://veneliniliev.com>
 */

import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { FacilitiesService } from '@app/settings/facilities/facilities.service';
import { Locale } from '@app/settings/locales/locales.model';
import { Logger } from '@app/core';
import { Facility } from '@app/settings/facilities/facilities.model';

const log = new Logger('facilitiesFormComponent');

@Component({
  selector: 'app-facilities-form',
  templateUrl: './facilities-form.component.html',
  styleUrls: ['./facilities-form.component.scss'],
})
export class FacilitiesFormComponent implements OnInit {
  @Input() facility: Facility = null;

  form: FormGroup;

  constructor(
    public modal: NgbActiveModal,
    private formBuilder: FormBuilder,
    private facilityService: FacilitiesService
  ) {}

  ngOnInit() {
    this.createForm();
  }

  save() {
    log.debug(this);
    if (!this.facility) {
      const facility: Facility = new Locale().deserialize(this.form.value);
      this.facilityService.store(facility).subscribe((res) => this.modal.close('Save click'));
    } else {
      const facility: Facility = this.facility.deserialize(this.form.value);
      this.facilityService.update(facility).subscribe((res) => this.modal.close('Save click'));
    }
  }

  private createForm() {
    this.form = this.formBuilder.group({
      name: ['', [Validators.required]],
      active: [true],
    });

    if (this.facility) {
      this.form.patchValue(this.facility);
    }
  }
}
